import workspaceRepository from "../../repository/WorkspaceRepository";
import {AxiosError} from "axios";
import {useQuery} from "@tanstack/react-query";
import {WorkspaceCard} from "@/model/transaction/transaction";

const getDate = async (workspaceId: string) => {
    try {
        const {data} = await workspaceRepository.readWorkspaceCard(workspaceId);
        return data.result;
    } catch (e) {
        throw e;
    }
}

const useWorkspaceCard = (workspaceId: string) => {
    return useQuery<WorkspaceCard, AxiosError>({
        queryKey: ["workspaceCard", workspaceId],
        queryFn: async () => getDate(workspaceId),
        retry: false,
        suspense: false
    })
}

export default useWorkspaceCard;
